'use strict';
module.exports = require('./Inplace.vue');